<header class="ts-header has-sticky hidden-currency hidden-language sticky" [class.fixed]="stick">
	<div class="header-container">
		<div class="header-template">
			<div id="undefined-sticky-wrapper" class="sticky-wrapper">
				<div class="header-sticky">
					<div class="header-middle">
						<div class="container-fluid">

							<div class="header-left">
								<div class="logo-wrapper">
									<div class="logo" (click)="navigate()">
										<a *ngIf="globalService.getCurrentLanguage() === 'en'">
											<img src="assets/images/logos/header-alt-logo.svg" alt="Megamart"
												title="Megamart" class="normal-logo">

											<img src="assets/images/logos/header-alt-logo.svg" alt="Megamart"
												title="Megamart" class="mobile-logo">

											<img src="assets/images/logos/header-alt-logo.svg" alt="Megamart"
												title="Megamart" class="sticky-logo">

										</a>
										<a *ngIf="globalService.getCurrentLanguage() === 'ar'">
											<img src="assets/images/logos/header-alt-arabic-logo.svg" alt="Megamart"
												title="Megamart" class="normal-logo">

											<img src="assets/images/logos/header-alt-arabic-logo.svg" alt="Megamart"
												title="Megamart" class="mobile-logo">

											<img src="assets/images/logos/header-alt-arabic-logo.svg" alt="Megamart"
												title="Megamart" class="sticky-logo">

										</a>
									</div>
								</div>
							</div>
							<img *ngIf="!isKeyFrame" src="assets/images/icon/mega-menu-icon.svg" alt="Menu"  style="margin-right: 10px;margin-left: 10px;" (click)="openPopup()">
							<div class="dropdown" *ngIf="authUser && addressList && addressList?.length > 0 && !isKeyFrame">
								<button class="btn btn-default dropdown-toggle" type="button" id="menu1"
									data-toggle="dropdown" (click)="toggleMenu()" *ngIf="selectedAddress">
									<div class="address-content">
										<div class="addressLabel">
											<!-- <img src="../../../../assets/images/icon/location.svg" alt=""> -->
											<img *ngIf="selectedAddress.address_type === 'Home'" src="assets/images/icon/homeicon.svg" alt="homeicon.svg" class="img-fluid">
											<img *ngIf="selectedAddress.address_type === 'Office'" src="assets/images/icon/address_office_icon.svg"
												alt="address_office_icon.svg" class="img-fluid">
											<img *ngIf="selectedAddress.address_type === 'Others'" src="assets/images/icon/address_other_icon.svg"
												alt="address_other_icon.svg" class="img-fluid">
											<img *ngIf="selectedAddress.address_type === 'Guest House'" src="assets/images/icon/guest_house_icon.svg"
												alt="guest_house_icon.svg" class="img-fluid">
											<div>{{ 'common.label.deliveringto' | translate}}</div>
										</div>
										<div class="d-flex justify-content-between">
											<div class="address" title="{{selectedAddress?.address1}} {{selectedAddress?.address2}}">{{selectedAddress?.address1}} {{selectedAddress?.address2}}</div>
											<img class="dropdownIcon" src="../../../../assets/images/icon/dropdown.svg" #toggleButton alt="" style="position: absolute;
											margin-left: 165px;">
										</div>
									</div>
									<!-- <i class="fa fa-angle-down" ></i> -->
								</button>
								<ul class="dropdown-menu arrow-up" role="menu" aria-labelledby="menu"
									[ngClass]="{'show': isMenuOpen}" #menu>
									<!-- (click)="setAddress(address)" -->
									<li role="presentation" class="addressOptions" (click)="setAsDefaultAddress(i, address)"
										*ngFor="let address of addressOptions;let i = index">
										<div class="addressLabel">
											<div>{{address.address_type}}</div>
										</div>
										<div class="address"  title="{{address?.address1}} {{address?.address2}}">{{address?.address1}} {{address?.address2}}</div>
									</li>
									<li role="presentation" (click)="navigatetoAddNewAddress();"
										[routerLink]="['pages/myaddress']" [queryParams]="{ action:'addNew' }">
										<div style="background-color: #fafafa;border-radius:4px"><button
												class="gradient-btn-o btn-block"><img
													src="assets/images/icon/add_address.svg" alt=""><span>{{
													'myprofile.myaddress.label.addnewaddress' |
													translate}}</span></button>
										</div>
									</li>
								</ul>
							</div>
							<!-- Menu Icon -->
							<!-- <button mat-button [matMenuTriggerFor]="menu" class="my-full-width-menu" >Menu</button> -->


							<div class="icon-menu-sticky-header hidden-phone">
								<span class="icon"></span>
							</div>
							<div class="ts-search-by-category hidden-phone" *ngIf="!isKeyFrame">
								<form method="get" action="https://demo.theme-sky.com/agrofood/" id="searchform-592">
									<div class="search-table">
										<div class="search-field search-content">
											<!-- <input type="text" value="" name="s" id="s-592"
												placeholder="Search for products" autocomplete="off"> -->
											<div class="ng-autocomplete" style="width:unset">
												<ng-autocomplete [data]="products" [searchKeyword]="keyword"
													minQueryLength=3
													placeholder="{{'menu.label.searchforproducts' | translate}}"
													(selected)='selectEvent($event)' #auto
													(inputChanged)='onChangeSearch($event)'
													(inputCleared)="onCleared($event)"
													(inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate"
													[notFoundTemplate]="notFoundTemplate"
													(keyup.enter)="search()">
												</ng-autocomplete>

												<ng-template #itemTemplate let-item>
													<a [innerHTML]="item.name"></a>
												</ng-template>

												<ng-template #notFoundTemplate let-notFound>
													<div [innerHTML]="notFound"></div>
												</ng-template>
											</div>
										</div>
										<!-- <div class="search-button"> -->
										<!-- <i class="fa fa-search"></i> -->
										<img src="assets/images/icon/search.svg" alt="search" (click)="search()" >
										<!-- <input type="submit" id="searchsubmit-592" value="Search"> -->
										<!-- </div> -->
									</div>
								</form>
							</div>




							<div class="header-right" *ngIf="!isKeyFrame">


								<div class="search-button search-icon visible-phone">
									<span class="icon"></span>
								</div>
								<div class="my-notification-wrapper  hidden-phone">
									<div class="notification-icon">
										<a class="tini-wishlist" (click)="updateDelivery()" [ngClass]="{'disable-delivery-update' : disableDeliveryUpdate || storeId != 5}">
											<img [src]="(deliveryType == 'Instant') ? 'assets/images/icon/scheduled-delivery.svg' :'assets/images/icon/instant-delivery.svg' "
												alt="" [title]="(deliveryType == 'Instant') ? 'Instant' : 'Scheduled'">
										</a>
									</div>
								</div>
								<div class="my-notification-wrapper  hidden-phone">
									<div class="notification-icon" (click)="customizeLayoutType(layout)">
										<a *ngIf="globalService.getCurrentLanguage() === 'en'" class="tini-wishlist">
											<img src="../../../../assets/images/icon/changelanguage.svg" alt=""
												title="Change language">
										</a>
										<a *ngIf="globalService.getCurrentLanguage() === 'ar'" class="tini-wishlist">
											<img src="../../../../assets/images/icon/lang_eng.svg" alt=""
												title="Change language">	
										</a>
									</div>
								</div>
								<div class="shopping-cart-wrapper hidden-phone">
									<div class="ts-tiny-cart-wrapper">
										<div class="cart-icon">
											<a class="cart-control"
												title="{{ 'myprofile.myaddress.label.viewshoppingcart' |translate}}"
												(click)="validateUser('/shop/cart-view')">
												<span class="img-cart">
													<img src="../../../../assets/images/icon/carticon.svg" alt="">
												</span>
												<span class="cart-number">{{cartCount}}</span>
											</a>
										</div>

										<!-- <div class="cart-dropdown-form woocommerce">
											<div class="form-content text-center">
												<label>
													<svg width="150" height="150" viewBox="0 0 150 150" fill="none"
														xmlns="http://www.w3.org/2000/svg">
														<path d="M150 0H0V150H150V0Z" fill="white"></path>
														<path
															d="M34.5824 74.3272L33.4081 68.3582C32.1926 62.179 36.9225 56.428 43.2201 56.428H131.802C138.025 56.428 142.737 62.0523 141.647 68.1798L130.534 130.633C129.685 135.406 125.536 138.882 120.689 138.882H56.6221C51.9655 138.882 47.9253 135.668 46.8782 131.13L45.1458 123.623"
															stroke="#808080" stroke-width="3" stroke-linecap="round">
														</path>
														<path
															d="M83.5444 17.835C84.4678 16.4594 84.1013 14.5956 82.7257 13.6721C81.35 12.7486 79.4862 13.1152 78.5628 14.4908L47.3503 60.9858C46.4268 62.3614 46.7934 64.2252 48.169 65.1487C49.5446 66.0721 51.4084 65.7056 52.3319 64.33L83.5444 17.835Z"
															fill="#808080"></path>
														<path
															d="M122.755 64.0173C124.189 64.8469 126.024 64.3569 126.854 62.9227C127.683 61.4885 127.193 59.6533 125.759 58.8237L87.6729 36.7911C86.2387 35.9614 84.4035 36.4515 83.5739 37.8857C82.7442 39.3198 83.2343 41.155 84.6684 41.9847L122.755 64.0173Z"
															fill="#808080"></path>
														<path
															d="M34.9955 126.991C49.3524 126.991 60.991 115.352 60.991 100.995C60.991 86.6386 49.3524 75 34.9955 75C20.6386 75 9 86.6386 9 100.995C9 115.352 20.6386 126.991 34.9955 126.991Z"
															stroke="#808080" stroke-width="2" stroke-linejoin="round"
															stroke-dasharray="5 5"></path>
														<path
															d="M30.7 100.2C30.7 99.3867 30.78 98.64 30.94 97.96C31.1 97.2667 31.3333 96.6734 31.64 96.18C31.9467 95.6734 32.3133 95.2867 32.74 95.02C33.18 94.74 33.6667 94.6 34.2 94.6C34.7467 94.6 35.2333 94.74 35.66 95.02C36.0867 95.2867 36.4533 95.6734 36.76 96.18C37.0667 96.6734 37.3 97.2667 37.46 97.96C37.62 98.64 37.7 99.3867 37.7 100.2C37.7 101.013 37.62 101.767 37.46 102.46C37.3 103.14 37.0667 103.733 36.76 104.24C36.4533 104.733 36.0867 105.12 35.66 105.4C35.2333 105.667 34.7467 105.8 34.2 105.8C33.6667 105.8 33.18 105.667 32.74 105.4C32.3133 105.12 31.9467 104.733 31.64 104.24C31.3333 103.733 31.1 103.14 30.94 102.46C30.78 101.767 30.7 101.013 30.7 100.2ZM29 100.2C29 101.6 29.22 102.84 29.66 103.92C30.1 105 30.7067 105.853 31.48 106.48C32.2667 107.093 33.1733 107.4 34.2 107.4C35.2267 107.4 36.1267 107.093 36.9 106.48C37.6867 105.853 38.3 105 38.74 103.92C39.18 102.84 39.4 101.6 39.4 100.2C39.4 98.8 39.18 97.56 38.74 96.48C38.3 95.4 37.6867 94.5534 36.9 93.94C36.1267 93.3134 35.2267 93 34.2 93C33.1733 93 32.2667 93.3134 31.48 93.94C30.7067 94.5534 30.1 95.4 29.66 96.48C29.22 97.56 29 98.8 29 100.2Z"
															fill="#808080"></path>
														<path
															d="M84.6121 101.029C85.8347 99.6106 88.8961 97.625 91.3609 101.029"
															stroke="#808080" stroke-width="3" stroke-linecap="round"
															stroke-linejoin="round"></path>
														<path
															d="M74.1953 92.2265C75.8158 92.2265 77.1296 90.9128 77.1296 89.2922C77.1296 87.6716 75.8158 86.3579 74.1953 86.3579C72.5747 86.3579 71.261 87.6716 71.261 89.2922C71.261 90.9128 72.5747 92.2265 74.1953 92.2265Z"
															fill="#808080"></path>
														<path
															d="M103.538 92.226C105.159 92.226 106.472 90.9123 106.472 89.2917C106.472 87.6711 105.159 86.3574 103.538 86.3574C101.917 86.3574 100.604 87.6711 100.604 89.2917C100.604 90.9123 101.917 92.226 103.538 92.226Z"
															fill="#808080"></path>
													</svg>
													<span>{{ 'myprofile.myaddress.label.cartcurrentlyempty'
														|translate}}</span></label>
											</div>
											<div class="dropdown-menu arrow-up  dropdown-container cart-section ">
												<div class="table-wrapper">
													<table mat-table [dataSource]="dataSource"
														class="table cart-table table-responsive-xs">


														<ng-container matColumnDef="image">
															<td mat-cell *matCellDef="let element">
																<div class="items d-flex align-items-center">
																	<img src="assets/images/cart/cart_image1.svg" alt=""
																		class="img-fluid">

																</div>
															</td>
														</ng-container>


														<ng-container matColumnDef="items">
															<td mat-cell *matCellDef="let element" height="100%">

																<p class="cart_title">
																	{{element.product_response_model.name}}</p>

																<div
																	class="d-flex justify-content-between align-items-center">
																	<span class="cart_amount">
																		<b>{{element?.product_response_model?.tier_prices[0]?.Price}}</b>&nbsp;
																	</span>
																	<div class="qty-box">
																		<div class="input-group">
																			<span class="input-group-prepend">
																				<button type="button"
																					class="btn quantity-left-minus"
																					data-type="minus"
																					(click)="decrement(element)">
																					<i class="fa fa-minus"
																						aria-hidden="true"></i>
																				</button>
																			</span>
																			<input type="text" name="quantity"
																				class="form-control input-number quantity_number"
																				disabled [(ngModel)]="element.quantity">
																			<span class="input-group-prepend">
																				<button type="button"
																					class="btn quantity-right-plus"
																					data-type="plus"
																					(click)="increment(element)">
																					<i class="fa fa-plus"
																						aria-hidden="true"></i>
																				</button>
																			</span>
																		</div>
																	</div>
																</div>
															</td>
														</ng-container>


														<tr mat-row *matRowDef="let row; columns: displayedColumns;">
														</tr>
													</table>
												</div>
												<button class="btn btn-block gradient-btn mt-2"
													routerLink="/shop/checkout">{{'mycart.label.checkout' |
													translate}}</button>
											</div>
										</div> -->
									</div>


								</div>

								<div class="my-notification-wrapper  hidden-phone">
									<div class="notification-icon">
										<a title="{{ 'myprofile.myaddress.label.notification' |translate}}"
											(click)="validateUser('/pages/notification')" class="tini-wishlist">
											<img src="../../../../assets/images/icon/notificationicon.svg" alt="">

											<span class="count-number">{{notificationCount}}</span>
										</a>
									</div>
								</div>
								<div class="my-account-wrapper hidden-phone">
									<div class="ts-tiny-account-wrapper ts-style-icon">
										<div class="account-control">
											<a class="my-account" *ngIf="!authUser"
												title="{{ (authUser ? 'myprofile.myaddress.label.loginregister': 'myprofile.myaddress.label.loginregister') |translate}}"
												(click)="validateUser('/pages/edit-profile');">

												<img src="../../../../assets/images/icon/user.svg" alt="">
											</a>
											<a class="my-account" *ngIf="authUser"
												title="{{loggedInUser}}"
												(click)="validateUser('/pages/edit-profile');">

												<img src="../../../../assets/images/icon/user.svg" alt="">
											</a>											
										</div>
									</div>
								</div>


							</div>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>	
</header>

<!-- mobile header -->
<!-- <div id="ts-mobile-button-bottom">
	<div class="ts-mobile-icon-toggle">
		<span class="icon"></span>
	</div>

	<div class="mobile-button-home">
		<a href="https://demo.theme-sky.com/agrofood/">
			<span class="icon"></span>
		</a>
	</div>

	<div class="my-account-wrapper">
		<div class="ts-tiny-account-wrapper ts-style-icon">
			<div class="account-control">
				<a class="my-account" href="https://demo.theme-sky.com/agrofood/my-account/" title="Login/Register">
				</a>
			</div>
		</div>
	</div>

	<div class="my-wishlist-wrapper"> <a title="Wishlist" href="https://demo.theme-sky.com/agrofood/wishlist/"
			class="tini-wishlist">
			<span class="count-number">0</span>
		</a>
	</div>

	<div class="shopping-cart-wrapper mobile-cart">
		<div class="ts-tiny-cart-wrapper">
			<div class="cart-icon">
				<a class="cart-control" href="https://demo.theme-sky.com/agrofood/cart/"
					title="View your shopping cart">
					<span class="ic-cart"></span>
					<span class="cart-number">0</span>
					<span class="cart-total"><span class="woocommerce-Price-amount amount"><bdi><span
									class="woocommerce-Price-currencySymbol">$</span>0.00</bdi></span></span>
				</a>
			</div>

			<div class="cart-dropdown-form dropdown-container woocommerce">
				<div class="form-content">
					<label><svg width="150" height="150" viewBox="0 0 150 150" fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<path d="M150 0H0V150H150V0Z" fill="white"></path>
							<path
								d="M34.5824 74.3272L33.4081 68.3582C32.1926 62.179 36.9225 56.428 43.2201 56.428H131.802C138.025 56.428 142.737 62.0523 141.647 68.1798L130.534 130.633C129.685 135.406 125.536 138.882 120.689 138.882H56.6221C51.9655 138.882 47.9253 135.668 46.8782 131.13L45.1458 123.623"
								stroke="#808080" stroke-width="3" stroke-linecap="round"></path>
							<path
								d="M83.5444 17.835C84.4678 16.4594 84.1013 14.5956 82.7257 13.6721C81.35 12.7486 79.4862 13.1152 78.5628 14.4908L47.3503 60.9858C46.4268 62.3614 46.7934 64.2252 48.169 65.1487C49.5446 66.0721 51.4084 65.7056 52.3319 64.33L83.5444 17.835Z"
								fill="#808080"></path>
							<path
								d="M122.755 64.0173C124.189 64.8469 126.024 64.3569 126.854 62.9227C127.683 61.4885 127.193 59.6533 125.759 58.8237L87.6729 36.7911C86.2387 35.9614 84.4035 36.4515 83.5739 37.8857C82.7442 39.3198 83.2343 41.155 84.6684 41.9847L122.755 64.0173Z"
								fill="#808080"></path>
							<path
								d="M34.9955 126.991C49.3524 126.991 60.991 115.352 60.991 100.995C60.991 86.6386 49.3524 75 34.9955 75C20.6386 75 9 86.6386 9 100.995C9 115.352 20.6386 126.991 34.9955 126.991Z"
								stroke="#808080" stroke-width="2" stroke-linejoin="round" stroke-dasharray="5 5"></path>
							<path
								d="M30.7 100.2C30.7 99.3867 30.78 98.64 30.94 97.96C31.1 97.2667 31.3333 96.6734 31.64 96.18C31.9467 95.6734 32.3133 95.2867 32.74 95.02C33.18 94.74 33.6667 94.6 34.2 94.6C34.7467 94.6 35.2333 94.74 35.66 95.02C36.0867 95.2867 36.4533 95.6734 36.76 96.18C37.0667 96.6734 37.3 97.2667 37.46 97.96C37.62 98.64 37.7 99.3867 37.7 100.2C37.7 101.013 37.62 101.767 37.46 102.46C37.3 103.14 37.0667 103.733 36.76 104.24C36.4533 104.733 36.0867 105.12 35.66 105.4C35.2333 105.667 34.7467 105.8 34.2 105.8C33.6667 105.8 33.18 105.667 32.74 105.4C32.3133 105.12 31.9467 104.733 31.64 104.24C31.3333 103.733 31.1 103.14 30.94 102.46C30.78 101.767 30.7 101.013 30.7 100.2ZM29 100.2C29 101.6 29.22 102.84 29.66 103.92C30.1 105 30.7067 105.853 31.48 106.48C32.2667 107.093 33.1733 107.4 34.2 107.4C35.2267 107.4 36.1267 107.093 36.9 106.48C37.6867 105.853 38.3 105 38.74 103.92C39.18 102.84 39.4 101.6 39.4 100.2C39.4 98.8 39.18 97.56 38.74 96.48C38.3 95.4 37.6867 94.5534 36.9 93.94C36.1267 93.3134 35.2267 93 34.2 93C33.1733 93 32.2667 93.3134 31.48 93.94C30.7067 94.5534 30.1 95.4 29.66 96.48C29.22 97.56 29 98.8 29 100.2Z"
								fill="#808080"></path>
							<path d="M84.6121 101.029C85.8347 99.6106 88.8961 97.625 91.3609 101.029" stroke="#808080"
								stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
							<path
								d="M74.1953 92.2265C75.8158 92.2265 77.1296 90.9128 77.1296 89.2922C77.1296 87.6716 75.8158 86.3579 74.1953 86.3579C72.5747 86.3579 71.261 87.6716 71.261 89.2922C71.261 90.9128 72.5747 92.2265 74.1953 92.2265Z"
								fill="#808080"></path>
							<path
								d="M103.538 92.226C105.159 92.226 106.472 90.9123 106.472 89.2917C106.472 87.6711 105.159 86.3574 103.538 86.3574C101.917 86.3574 100.604 87.6711 100.604 89.2917C100.604 90.9123 101.917 92.226 103.538 92.226Z"
								fill="#808080"></path>
						</svg>
						<span>Your cart is currently empty</span></label>
				</div>
			</div>
		</div>

	</div>
</div> -->
<!-- mobile header -->